import React from 'react'
import {
  ListNav,
  Sidebar,
  Featured
} from './index'
import PaginatedList from './paginated-list'
import { QUERY_BLACKLIST as BLACKLIST } from '../../../constants'

const MainContent = ({
  embed,
  events = [],
  query = {},
  defaultItems,
  defaultFeaturedItems,
  pageConfig,
  actions
}) => {
  const data = defaultItems ? defaultItems : events
  const filteredKeys = Object.keys(query).filter(key => BLACKLIST.includes(key) === false)
  const showFeatured = filteredKeys.length === 0

  return (
    <section className="container mx-auto hidden lg:block">
      <div className={`flex flex-wrap -mx-4 ${!embed && 'py-16'}`}>
        <aside className="w-3/12 px-4">
          <Sidebar query={query}/>
        </aside>
        <main className="w-9/12 px-4">
          {
            (!embed && showFeatured) &&
            <Featured embed={embed} defaultItems={defaultFeaturedItems}/>
          }
          <ListNav />
          {
            (embed && showFeatured) &&
            <Featured embed={embed} defaultItems={defaultFeaturedItems}/>
          }
          <PaginatedList
            query={query}
            events={data}
            pageConfig={pageConfig}
            actions={actions}
          />
        </main>
      </div>
    </section>
  )
}

export { MainContent }
